export default "__VITE_ASSET__C8qKDtrs__"